import { instance } from "apis/interceptor";
import { UserRole } from "utils/role";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

export type TMember = {
  id: string;
  nickname: string;
  image: string;
  role: UserRole;
  accessedAt: string;
  deleteFlag: boolean;
  googleOrgUnit?: string;
  email: string;
};

//FEAT: (new) 멤버 조회
export const getMemberList = async (
  page: number,
  role?: number,
  search?: string
): Promise<{
  success?: boolean;
  totalPageNumber?: number;
  totalSearchNumber?: number;
  nowPageNumber?: number;
  memberList?: TMember[];
  message?: string;
}> => {
  try {
    const res = await instance.post("/members", {
      nowPageNumber: page,
      role: role ?? null,
      searchWord: search ?? null,
    });

    const { totalSearchNumber, totalPageNumber, nowPageNumber, memberList } = res.data;

    return {
      success: true,
      totalSearchNumber,
      totalPageNumber,
      nowPageNumber,
      memberList,
    };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: `${error}`,
    };
  }
};

//FEAT: (new) 멤버 권한 수정
export const updateMemberRole = async (
  id: string,
  role: number
): Promise<{
  success?: boolean;
  message?: string;
}> => {
  try {
    const res = await instance.patch("/members/role", {
      id: id,
      role: role,
    });

    return {
      success: res.data.result,
    };
  } catch (error: any) {
    console.error(error);

    const statusCode = error.response.status;
    if (statusCode === 403) {
      return { success: false, message: "수정 권한이 없습니다. 권한을 확인해주세요." };
    } else {
      return { success: false, message: `${error}` };
    }
  }
};

//FEAT: (new) 멤버 삭제
export const deleteMember = async (
  id: string
): Promise<{
  success?: boolean;
  message?: string;
}> => {
  try {
    const res = await instance.delete("auth/member", {
      data: {
        id: id,
      },
    });

    return {
      success: res.data.result,
    };
  } catch (error: any) {
    console.error(error);

    const statusCode = error.response.status;
    if (statusCode === 403) {
      return { success: false, message: "삭제 권한이 없습니다. 권한을 확인해주세요." };
    } else {
      return { success: false, message: `${error}` };
    }
  }
};

//FEAT: (new) 멤버 검색하기
export const searchMembers = async (member: string): Promise<ResponseType<TMember[]>> => {
  try {
    const res = await instance.get(`/members/search-member/${member}`);

    return { success: true, data: res.data };
  } catch (error: any) {
    console.error(error);

    const statusCode = error.response.status;
    if (statusCode === 403) {
      return { success: false, message: "삭제 권한이 없습니다. 권한을 확인해주세요." };
    } else {
      return { success: false, message: `${error}` };
    }
  }
};
